/** Copy shared by KM and RP so the recommendations experience reads the same on both portals. */

export const HOMEMATCH_TINDER_BANNER_RECOMMENDATION_READY_CONTENT = {
    TITLE: "Twoje wymarzone mieszkanie może być na tej liście",
    DESCRIPTION:
        "Wyselekcjonowaliśmy mieszkania idealnie odpowiadające Twoim kryteriom. Przejrzyj je, wybierz swoje ulubione i od razu wyślij zapytanie do dewelopera, by dopytać o szczegóły. Pamiętaj - najlepsze układy znikają z rynku błyskawicznie!",
    CTA: "Zobacz rekomendacje"
} as const;

export const HOMEMATCH_TINDER_ACTION_BAR_CONTENT = {
    ASK_BUTTON: "ZAPYTAJ",
    REJECT_BUTTON: "ODRZUĆ",
    VENDOR_LOGO_ALT: "Logo dewelopera",
    getLeadInfoText: (vendorName: string) => `Wysyłasz zapytanie do dewelopera ${vendorName}`
} as const;

export const HOMEMATCH_TINDER_SENT_LEAD_MESSAGE_CONTENT = {
    TITLE: "Twoje zapytanie zostało wysłane",
    getSubtitle: (vendorName: string) => `Oczekuj na wiadomość od konsultanta ${vendorName}`,
    ACCEPT_ERROR: "Wystąpił błąd podczas wysyłania zapytania. Spróbuj ponownie później."
} as const;
/** Copy shared by KM and RP so the recommendations experience reads the same on both portals. */

export const HOMEMATCH_TINDER_BANNER_RECOMMENDATION_READY_CONTENT = {
    TITLE: "Twoje wymarzone mieszkanie może być na tej liście",
    DESCRIPTION:
        "Wyselekcjonowaliśmy mieszkania idealnie odpowiadające Twoim kryteriom. Przejrzyj je, wybierz swoje ulubione i od razu wyślij zapytanie do dewelopera, by dopytać o szczegóły. Pamiętaj - najlepsze układy znikają z rynku błyskawicznie!",
    CTA: "Zobacz rekomendacje"
} as const;

export const HOMEMATCH_TINDER_ACTION_BAR_CONTENT = {
    ASK_BUTTON: "ZAPYTAJ",
    REJECT_BUTTON: "ODRZUĆ",
    VENDOR_LOGO_ALT: "Logo dewelopera",
    getLeadInfoText: (vendorName: string) => `Wysyłasz zapytanie do dewelopera ${vendorName}`
} as const;

export const HOMEMATCH_TINDER_SENT_LEAD_MESSAGE_CONTENT = {
    TITLE: "Twoje zapytanie zostało wysłane",
    getSubtitle: (vendorName: string) => `Oczekuj na wiadomość od konsultanta ${vendorName}`,
    ACCEPT_ERROR: "Wystąpił błąd podczas wysyłania zapytania. Spróbuj ponownie później."
} as const;
